import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator } from '@angular/material';
import { SnackbarService } from 'src/app/snackbar.service';
import { HttpService } from 'src/app/http.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ValidationService } from 'src/app/validation.service';

import { Messages } from '../../constants/messages';
import { SpotOnDriverComponent } from 'src/app/spot-on-driver/spot-on-driver.component';
import { TranslateService } from '@ngx-translate/core';
import { AddOwnFleetDriverComponent } from 'src/app/add-own-fleet-driver/add-own-fleet-driver.component';
import { TemplateRef } from '@angular/core';

enum status_string {
  online = 'Online',
  offline = 'Offline',
}

declare var google: any;

@Component({
  selector: 'app-assign-modal',
  templateUrl: './assign-modal.component.html',
  styleUrls: ['./assign-modal.component.scss']
})
export class AssignModalComponent implements OnInit {

  map;
  mapMarkers: any = [];
  truckIcon = {
    url: 'assets/truck-icon.svg',
    scaledSize: new google.maps.Size(30, 30)
  };
  picon = {
    url: 'assets/Pickup.svg', // url
    scaledSize: new google.maps.Size(30, 30)
  };
  data;
  url;
  bounds;
  mobile_number;
  vehicle_number;
  columnHeaders: string[] = ['select', 'vehicle', 'driverName', 'distance'];

  assignArr = [

  ];
  selection = new SelectionModel<any>(true, []);
  selectAll = false;
  orgDetails: any = {
    organizationName: '',
    orderNo: '',
    vehicleType: '',
    allocated: '',
  };

  location: any = {
    start: '',
    destination: '',
  };
  pickup;

  messages = new Messages();
  vehicle: any;
  totalAssigned = 0;
  showLoader = false;
  deliveries: any = [];
  assignFilter: any = {};
  dialogRef;
  inServiceVehicleNo = '';
  searchMobileNo = '';
  searchVehicleNo = '';
  //isPallet = false;
  vehicleByCapacity = false;
  isDedicatedTo = false;
  viewMapFlag:any = false;
  // allocation_type = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('warning', { static: true }) warning: TemplateRef<any>;

  constructor(private dialog: MatDialogRef<AssignModalComponent>,
    private translation: TranslateService,
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private snack: SnackbarService, private valid: ValidationService,
    private http: HttpService, private openDialog: MatDialog) { }

  ngOnInit() {

    // this.isPallet = this.parentData.order.uom === 'Pallets' ? true : false;
    this.pickup = this.parentData.order.from[0];
    this.deliveries = this.parentData.order.to;
    this.vehicleByCapacity = false;
    this.vehicle = this.parentData.order.vehicle;
    //this.allocation_type = this.parentData.order.allocation_type;
    this.orgDetails = {
      organizationName: this.parentData.order.shipper.name,
      orderNo: this.parentData.order.order,
      vehicleType: this.parentData.order.vehicle.name || '',

      allocated: this.parentData.order.accepted,
      to_be_assigned: this.parentData.order.to_be_assigned,
      bidding_type: this.parentData.order.bidding_type || '',
      allocation_type: this.parentData.order.allocation_type || ''
    };
    this.location = {
      start: this.parentData.order.from[0].loc_id.name,
      destination: this.parentData.order.to[this.parentData.order.to.length - 1].loc_id.name,
    };
    if (this.parentData.order.bidding_type == 'weight' || this.parentData.order.allocation_type == 'weight') {
      this.weightBasedOrder();
    }
    //if (this.isPallet) this.columnHeaders.push('pallet');
    if (this.parentData.order.bidding_type == 'Pallets' || this.parentData.order.allocation_type == 'Pallets') this.columnHeaders.push('pallet');

    this.getVehicleDetails();
  }

  weightBasedOrder() {
    this.columnHeaders.push('weight')
  }

  viewMap() {
    this.viewMapFlag =true;
    setTimeout(() => {
      this.initMap()
    }, 100)
  }

  initMap(lat = 0, lng = 0) {
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    };
    this.map = new google.maps.Map(document.getElementById('pathMap'), mapProp);
    google.maps.event.addListener(this.map, 'click', function (event) {
    });
    if(this.assignArr.length) {
      this.placeFirstPickup(this.pickup.loc_id, 'P1', this.picon);
      this.plotDrivers(this.assignArr);
    } else {
      if(this.viewMapFlag) this.map.setZoom(11);
      }
  }


  plotDrivers(drivers) {
    if (drivers.length) {
      drivers.forEach(element => {
        if (element.current_location.latitude && element.current_location.longitude) {
          const latLng = { lat: parseFloat(element.current_location.latitude), lng: parseFloat(element.current_location.longitude) };
          this.placeMarker(element.current_location, '', this.truckIcon, element.vehicle);
          this.bounds.extend(latLng); 
          if(this.map) {
          this.map.fitBounds(this.bounds);
          }
        }
      });
    } else {
      if(this.map) {
      this.map.setZoom(11);
      }
    }
  }

  placeMarker(location, label = '', icon: any = '',title: any ='') {
    if(this.map) {
    const markerOpt: any = {
      position: { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) },
      map: this.map,
      label: label || '',
      title: title || ''
    };
    (icon) ? markerOpt.icon = icon : '';

    const marker = new google.maps.Marker(markerOpt);
    this.mapMarkers.push(marker);
    marker.setMap(this.map);
   }
  }

  placeFirstPickup(location, label = '', icon: any = '') {
    // const bounds = new google.maps.LatLngBounds();
    if (location.geo_point.coordinates[0] &&  location.geo_point.coordinates[0]) {
      const markerOpt: any = {
        position: { lat: parseFloat(location.geo_point.coordinates[1]), lng: parseFloat(location.geo_point.coordinates[0]) },
        map: this.map,
        label: {
          text: label,
          color: "#fff",
        }
      };
      (icon) ? markerOpt.icon = icon : '';

      const latLng = {
        lat: location.geo_point.coordinates[1],
        lng: location.geo_point.coordinates[0]
      };

      const marker = new google.maps.Marker(markerOpt);
      this.mapMarkers.push(marker);
      marker.setMap(this.map);
      this.bounds.extend(latLng);
      this.map.fitBounds(this.bounds);
    }
  }

  removeMarkers(markers) {
    markers.forEach(element => element.setMap(null));
    if(this.viewMapFlag) this.map.setZoom(12);
  }

  closeAssignModal(data = '') {
    this.removeMarkers(this.mapMarkers);
    this.dialog.close(data);
  }
  getVehicleDetails(filter: any = {}) {

    filter.is_free = false;
    filter.limit = this.paginator.pageSize || 5;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    if (this.parentData.order.vehicle && this.parentData.order.vehicle._id) {
      filter.vehicle_type = this.parentData.order.vehicle._id;
    }
    if (this.searchMobileNo) {
      filter.mobile = this.searchMobileNo;
    }
    if (this.searchVehicleNo) {
      filter.vehicle_no = this.searchVehicleNo;
    }
    if (this.isDedicatedTo) {
      filter.dedicated_to = this.parentData.order.shipper._id;
    }
    filter.vehicle_by_capacity = this.vehicleByCapacity;
    this.http.get('driver/get_all_attached?order=' + this.parentData.order._id, filter).subscribe(
      (data: any) => {

        this.assignArr = [];
        this.assignArr.length = 0;
        this.totalAssigned = data.data.count;// data.data.length;
        const result = data.data.drivers;
        result.forEach(element => {
          let e: any = {
            select: false,
            driverName: element.name,
            driver_id: element._id,
            vehicle: element.vehicle_no,
            driverMobile: element.mobile,
            is_temporary: (element.driver_type && element.driver_type == 'temporary'),
            vehicle_type: element.vehicle_type ? element.vehicle_type : 'N/A',
            unitname: element.carrier_unit ? element.carrier_unit.name : '',
            distance: element.distance ? (element.distance / 1000).toFixed(0) : 'N/A',
            in_service: (element.vehicle) ? element.vehicle.maintenance ? element.vehicle.maintenance.in_service ? true : false : false : false,
            // PENDING::provision to be changed for different metrics as well
            status: element.status,
            status_string: element.status ? status_string[element.status] : 'N/A',
            current_location:  element.geo_point &&  element.geo_point.coordinates ?  { latitude: element.geo_point.coordinates[1], longitude: element.geo_point.coordinates[0] } : {},
            assigned_shipment: element.assigned_shipment ? element.assigned_shipment : ''
          }
          if (this.parentData.order.bidding_type == 'weight') {
            e.weight = 0;
          }
          this.assignArr.push(e);
        });
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('ASSIGN.pagination_label');


        // (this.mapMarkers.length) ? this.removeMarkers(this.mapMarkers) : '';
        this.bounds = new google.maps.LatLngBounds();
        if(this.map) {
        this.placeFirstPickup(this.pickup.loc_id, 'P1', this.picon);
        this.plotDrivers(this.assignArr);
        }
      },
      (err: any) => {
        this.snack.openSnackBar(err.error.message, '', 'err');
      }
    );

  }
  pageNavigate(event) {
    this.assignFilter.limit = event.pageSize;
    this.assignFilter.skip = event.pageIndex * event.pageSize;
    this.selectAll = false;
    this.getVehicleDetails(this.assignFilter);
  }
  applyFilter(filterValue: string, type: string) {
    if (type == 'mobile') {
      this.searchMobileNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 8) {
        this.getVehicleDetails();
      }

    } else if (type == 'vehicleno') {
      this.searchVehicleNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 3) {
        this.getVehicleDetails();
      }
    }

  }

  truncate(num) {
    return Math.trunc(num * Math.pow(10, 2)) / Math.pow(10, 2);
  }

  checkAllWeight(arr) {
    let total = 0;
    arr.forEach(e => {
      total += +e.weight;
    });
    if (this.orgDetails.bidding_type == 'weight') {
      return total > this.parentData.order.weight_based.pending;
    } else {
      total > this.parentData.assign_number;
    }

  }
  checkAllPallet(arr) {
    let total = 0;
    arr.forEach(e => {
      if (e.pallet) total += e.pallet;
    });
    return total > this.parentData.assign_number;
  }
  checkWeightForZeroValues(arr) {

    let e: any;
    for (e of arr) {
      if (+e.weight == 0 && e.select) {
        return true;
      }
    }
    return false;
  }
  checkPalletsForZeroValues(arr) {

    let e: any;
    for (e of arr) {
      if (+e.pallet == 0 && e.select) {
        return true;
      }
    }
    return false;
  }
  assign() {

    if (this.parentData.allocation_id) { //normal orders
      this.data = {
        order_id: this.parentData.order_id,
        allocation_id: this.parentData.allocation_id,
        driver_ids: this.assignArr.filter(item => item.select).map(item => item.driver_id)
      }
    } else { //bid orders
      this.data = {
        order_id: this.parentData.order_id,
        driver_ids: this.assignArr.filter(item => item.select).map(item => item.driver_id)
      }
    }
      this.url = "order/assignNew";

    if (this.parentData.order.bidding_type == 'weight' || this.parentData.order.allocation_type == 'weight') {
      this.url = "order/assign_weights";
      if (this.checkAllWeight(this.assignArr)) {
        this.snack.openSnackBar('Total weight exceeds requested weight', '', 'err');
        return false;
      }
      if (this.checkWeightForZeroValues(this.assignArr)) {
        this.snack.openSnackBar('Weight cannot be 0', '', 'err');
        return false;
      }


      this.data.weight_allocations = this.assignArr.filter(item => item.select).map(e => ({ driver_id: e.driver_id, weights: e.weight }));
      this.data.total_weights_allocated = this.assignArr.filter(item => item.select).reduce((a, b) => +a + +b.weight, 0);
    }
    // if (this.isPallet) {
    if (this.parentData.order.bidding_type == 'Pallets' || this.parentData.order.allocation_type == 'Pallets') {
      this.url = "order/assign_pallets";
      if (this.checkAllPallet(this.assignArr)) {
        this.snack.openSnackBar('Total pallets exceeds requested pallets', '', 'err');
        return false;
      }

      if (this.checkPalletsForZeroValues(this.assignArr)) {
        this.snack.openSnackBar('Pallets cannot be 0', '', 'err');
        return false;
      }


      this.data.pallet_allocations = this.assignArr.filter(item => item.select).map(e => ({ driver_id: e.driver_id, pallets: e.pallet }));
      this.data.total_pallets_allocated = this.assignArr.filter(item => item.select).reduce((a, b) => +a + +b.pallet, 0);
    }
    const inServiceVehicles = this.assignArr.filter(item => (item.select && item.in_service));
    let allocate = true;
    if (this.data.driver_ids.length) {
      if (this.data.driver_ids.length <= this.parentData.assign_number || this.parentData.order.bidding_type == 'weight') {
        if (inServiceVehicles.length) {
          allocate = false;
          this.inServiceVehicleNo = inServiceVehicles[0].vehicle;
          this.dialogRef = this.openDialog.open(this.warning);
          this.dialogRef.afterClosed().subscribe(
            (data: any) => {
              allocate = data;
              this.allocate(allocate);
            }
          );
        } else {
          this.allocate(allocate);
        }
      } else {
        this.showLoader = false;
        this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ASSIGN_MODAL.VALIDATION.EXCEEDS_ACCEPT, '', 'err');
      }
    } else {
      this.showLoader = false;
      this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ASSIGN_MODAL.VALIDATION.VEHICLE_SELECT, '', 'err');
    }
  }
  allocate(flag) {
    if (flag) {
      this.showLoader = true;

      this.http.post(this.url, this.data).subscribe(
        (data: any) => {
          this.showLoader = false;

          if (data.statusCode == 200) {
            this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ASSIGN_MODAL.SUCCESS.ORDER_ASSIGN);
            this.closeAssignModal(data);
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snack.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 401) {
            this.valid.logout();
          }
        }
      );
    } else this.showLoader = false;
  }
  openSpotDriver() {
    const data: any = {
      vehicle: this.vehicle
    };
    const dialogRef = this.openDialog.open(SpotOnDriverComponent, {
      data
    });
    dialogRef.afterClosed().subscribe(
      (data: any) => {
        if (data && data.statusCode === 200) {
          this.getVehicleDetails();
        }
      }
    );
  }
  openOwnFleetDriver() {
    const data: any = {
      vehicle: this.vehicle
    };
    const dialogRef = this.openDialog.open(AddOwnFleetDriverComponent, {
      data
    });
    dialogRef.afterClosed().subscribe(
      (data: any) => {
        if (data && data.statusCode === 200) {
          this.getVehicleDetails();
        }
      }
    );
  }
  isAllSelected() {
    let count = 0;
    this.assignArr.forEach(ele => {
      if (ele.select) {
        count++;
      }
    });
    const numSelected = count;
    const numRows = this.assignArr.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.assignArr.forEach(row => row.select = false) :
      this.assignArr.forEach(row => row.select = true);
  }
  clearMobileNumber() {
    this.mobile_number = '';
    this.applyFilter('', 'mobile');
  }
  clearVehicleNumber() {
    this.vehicle_number = '';
    this.applyFilter('', 'vehicleno')
  }
  vehicleCapacity() {
    this.vehicleByCapacity = !this.vehicleByCapacity;
    this.getVehicleDetails();
  }
  dedicatedTo() {
    this.isDedicatedTo = !this.isDedicatedTo;
    this.getVehicleDetails();
  }
}

